import { AUTH_PROFILE, AUTH_TOKEN } from "constants/AuthConstant";
import { eraseCookie } from "./CookieService";

export function autoLogout() {
  eraseCookie(AUTH_TOKEN);
  localStorage.removeItem(AUTH_PROFILE);
  window.location.href = "/auth/login";
}
